<template>
  <div class="change-club">
    <ul class="breadcrumb">
      <li><router-link to="/">Главная</router-link></li>
      <li class="active"><router-link to="/docs">Документы</router-link></li>
    </ul>
    <div class="page_header">
      <div class="page_header--title">
        Документы
      </div>
    </div>

    <div class="page_content">
      <documents-list
          :documents="documents"
      />
    </div>
  </div>
</template>

<script>
import DocumentsList from "../components/DocumentsList";
import api from "@/api";

export default {
  name: 'Documents',
  components: { DocumentsList },
  data() {
    return {
      documents: []
    };
  },
  created() {
    this.loadDocuments();
  },
  methods: {
    async loadDocuments() {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const clubId = urlParams.get('c');

        const params = {};
        if (clubId) {
          params['club_ids[]'] = clubId;
        }

        const response = await api.documents.getDocuments(params);
        this.documents = response.data;
        console.log(this.documents);
      } catch (error) {
        alert("Ошибка при загрузке документов: " + error);
      }
    },
  }
}
</script>